import { useCallback } from 'react';

import * as Types from '../types';

export const useXpointLiteConnect = ({
    sdk,
    onConnect
}: {
    sdk: Types.XPointLiteSDKInstance | null;
    onConnect: CallableFunction;
}) => {
    return useCallback(() => {
        if (!sdk) {
            return;
        }

        onConnect();
    }, [
        sdk,
        onConnect
    ]);
};
